import { GOVConfigProps } from "./GOV.type";

export const GOVConfig: GOVConfigProps = {
    url: "https://gateway.apiserpro.serpro.gov.br",
    clientSecret: process.env.REACT_APP_GOV_API_CLIENT_SECRET,
    clientId: process.env.REACT_APP_GOV_API_CLIENT_ID,
    scope: "api-cnpj-v1",
};

export default GOVConfig;
